/**
 * What a repeatable catalogue item's artwork is today and what ordering it
 * does (AW3c-4; brandhub-order-routing 13 §5.3): the line takes no files, the
 * item's artwork is reused. Shown on the staff catalogue item page.
 *
 * Both sentences are the read's (views words them); an expired or undated
 * revision is flagged, since the order is placed but its line is held.
 */
import { TriangleAlert } from "lucide-react";
import type { ItemArtworkValidity } from "@shared-core/data/artwork-staff-types";

export type RepeatableItemArtworkFacts = Pick<
  ItemArtworkValidity,
  "status" | "sentence" | "order_effect"
>;

const HELD: ReadonlySet<RepeatableItemArtworkFacts["status"]> = new Set([
  "expired",
  "undated",
]);

export function RepeatableItemArtworkNote({
  artwork,
  label,
}: {
  artwork: RepeatableItemArtworkFacts;
  /** The section's small heading: "Artwork" on the item page. */
  label: string;
}) {
  const isHeld = HELD.has(artwork.status);
  return (
    <section aria-label={label} className="space-y-1">
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className="text-sm">{artwork.sentence}</p>
      <p className="flex items-start gap-1.5 text-xs text-muted-foreground">
        {isHeld && (
          <TriangleAlert
            aria-hidden
            className="size-3.5 shrink-0 mt-px text-[color:var(--color-warning)]"
          />
        )}
        <span>{artwork.order_effect}</span>
      </p>
    </section>
  );
}
